import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Client-side gate only — the real gate is `protectAgency` on the backend,
// which every /api/agency/shifts/* request goes through regardless of what
// this component does. This just avoids flashing a shifts screen with no
// data (and the resulting failed requests) before bouncing to /login.
const PrivateRoute = () => {
  const { agencyInfo } = useSelector((state) => state.agencyAuth);
  const location = useLocation();

  return agencyInfo ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default PrivateRoute;
